module.exports = __webpack_public_path__ + "static/media/acdc_logo.2b8d4855.svg";